var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4682",
    "data-name": "Raggruppa 4682",
    transform: "translate(-311 -296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4681",
    "data-name": "Raggruppa 4681",
    transform: "translate(39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2119",
    "data-name": "Rettangolo 2119",
    width: 24,
    height: 24,
    transform: "translate(272 296)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4679",
    "data-name": "Raggruppa 4679",
    transform: "translate(40 -62.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_82",
    "data-name": "Tracciato 82",
    d: "M456.044-884.838H436.927a1.468,1.468,0,0,1-1.434-1.5,1.468,1.468,0,0,1,1.434-1.5h19.117a1.468,1.468,0,0,1,1.434,1.5A1.468,1.468,0,0,1,456.044-884.838Z",
    transform: "translate(-163.493 1248.692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_83",
    "data-name": "Tracciato 83",
    d: "M456.044-884.838H436.927a1.468,1.468,0,0,1-1.434-1.5,1.468,1.468,0,0,1,1.434-1.5h19.117a1.468,1.468,0,0,1,1.434,1.5A1.468,1.468,0,0,1,456.044-884.838Z",
    transform: "translate(-163.493 1257.192)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_84",
    "data-name": "Tracciato 84",
    d: "M456.044-884.838H436.927a1.468,1.468,0,0,1-1.434-1.5,1.468,1.468,0,0,1,1.434-1.5h19.117a1.468,1.468,0,0,1,1.434,1.5A1.468,1.468,0,0,1,456.044-884.838Z",
    transform: "translate(-163.493 1265.692)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.d47ac645d699023cb49215fce9fb3df9.svg";
export { ForwardRef as ReactComponent };